import type { PartialDeep } from "type-fest";

export const deepCleanObject = <T extends object>(obj: T) => {
  const copy: PartialDeep<T> = {} as PartialDeep<T>;
  for (const key in obj) {
    const value = obj[key];
    if (value !== undefined && value !== null && value !== "" && (!Array.isArray(value) || value.length > 0)) {
      if (!Array.isArray(value) && !(value instanceof Date) && typeof value === "object") {
        const cleanedValue = deepCleanObject(value);
        if (cleanedValue) {
          copy[key as string] = cleanedValue;
        }
      } else {
        copy[key as string] = value;
      }
    }
  }
  return Object.keys(copy).length > 0 ? copy : null;
};

export const deepCleanObjectWithNull = <T extends object>(obj: T) => {
  const copy: PartialDeep<T> = {} as PartialDeep<T>;
  for (const key in obj) {
    const value = obj[key];
    if (value !== undefined && value !== "" && (!Array.isArray(value) || value.length > 0)) {
      if (!Array.isArray(value) && !(value instanceof Date) && typeof value === "object" && value !== null) {
        const cleanedValue = deepCleanObjectWithNull(value);
        if (cleanedValue) {
          copy[key as string] = cleanedValue;
        }
      } else {
        copy[key as string] = value;
      }
    }
  }
  return Object.keys(copy).length > 0 ? copy : null;
};
